var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaitingMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#9A9A9A;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st2{fill:#9A9A9A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.3,1.9h9.3c0.6,0,1.2,0.5,1.2,1.2v10.7c0,0.6-0.5,1.2-1.2,1.2H3.3c-0.6,0-1.2-0.5-1.2-1.2V3.1 C2.2,2.4,2.7,1.9,3.3,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.7,0.3h4.6c0.4,0,0.8,0.3,0.8,0.8V3c0,0.4-0.3,0.8-0.8,0.8H5.7C5.3,3.7,4.9,3.4,4.9,3V1 C4.9,0.6,5.3,0.3,5.7,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.1,4.8h0.6c0.1,0,0.2,0.1,0.2,0.2v0.6c0,0.1-0.1,0.2-0.2,0.2H4.1C4,5.8,3.9,5.7,3.9,5.6V5 C3.9,4.9,4,4.8,4.1,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.9,5.7H5.4c-0.1,0-0.2-0.1-0.2-0.2V5c0-0.1,0.1-0.2,0.2-0.2h6.5c0.1,0,0.2,0.1,0.2,0.2v0.6 C12.1,5.7,12,5.7,11.9,5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.1,6.8h0.6c0.1,0,0.2,0.1,0.2,0.2v0.6c0,0.1-0.1,0.2-0.2,0.2H4.1C4,7.7,3.9,7.6,3.9,7.5V7 C3.9,6.9,4,6.8,4.1,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.9,7.7H5.4c-0.1,0-0.2-0.1-0.2-0.2V6.9c0-0.1,0.1-0.2,0.2-0.2h6.5c0.1,0,0.2,0.1,0.2,0.2v0.6 C12.1,7.6,12,7.7,11.9,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.1,8.7h0.6c0.1,0,0.2,0.1,0.2,0.2v0.6c0,0.1-0.1,0.2-0.2,0.2H4.1C4,9.7,3.9,9.6,3.9,9.5V8.9 C3.9,8.8,4,8.7,4.1,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.9,9.6H5.4c-0.1,0-0.2-0.1-0.2-0.2V8.9c0-0.1,0.1-0.2,0.2-0.2h6.5c0.1,0,0.2,0.1,0.2,0.2v0.6 C12.1,9.6,12,9.6,11.9,9.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingMenu);
export default __webpack_public_path__ + "static/media/waiting-menu.2194176dae6bc572b7cfbc016e9334b0.svg";
export { ForwardRef as ReactComponent };